import useCrud from 'hooks/useCrud';
import {
  voucherAvailableProductList,
  VoucherAvailableProductListParams,
} from 'services/api/conversation';

const readList = (params: VoucherAvailableProductListParams) => {
  return voucherAvailableProductList(params).then((res = []) => res);
};

function useVoucherProduct() {
  return useCrud({
    readList,
  });
}

export default useVoucherProduct;
